module.exports = __webpack_public_path__ + "static/img/real-star-1.979275b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Scenes/Home/StarField/img/real-star-1.png
// module id = 342
// module chunks = 0